import {Box} from "@mui/material";
import React from "react";
import {Route, Routes} from "react-router-dom";
import {RecoilRoot} from "recoil";
import PageNotFound from "../../util/page/PageNotFound";
import OperatorList from "./page/OperatorList";
import OperatorCreate from "./page/OperatorCreate";
import ProfileList from "./page/ProfileList";
import ProfileCreate from "./page/ProfileCreate";
import OperatorUpdate from "./page/OperatorUpdate";
import ProfileUpdate from "./page/ProfileUpdate";

//test 2
const OperatorMain = () => {

    return (
        <Box>
            <Routes>
                <Route path="/list" element={
                    <RecoilRoot>
                        <OperatorList/>
                    </RecoilRoot>
                }/>
                <Route path="/create" element={
                    <RecoilRoot>
                        <OperatorCreate/>
                    </RecoilRoot>
                }/>
                <Route path="/list/:id" element={
                    <RecoilRoot>
                        <OperatorUpdate/>
                    </RecoilRoot>
                }/>
                <Route path="/profile/list" element={
                    <RecoilRoot>
                        <ProfileList/>
                    </RecoilRoot>
                }/>
                <Route path="/profile/create" element={
                    <RecoilRoot>
                        <ProfileCreate/>
                    </RecoilRoot>
                }/>

                <Route path="/profile/list/:id" element={
                    <RecoilRoot>
                        <ProfileUpdate/>
                    </RecoilRoot>
                }/>
                <Route path="*" element={<PageNotFound/>}/>
            </Routes>
        </Box>
    );
}

export default OperatorMain;
